"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../../container"));
var mediafiles_1 = require("../../stores/mediafiles");
var mediafiles_2 = require("../../selectors/mediafiles");
var mediafilesMeta_1 = require("../../stores/mediafilesMeta");
var startNextMediafileCleanup_1 = __importDefault(require("./startNextMediafileCleanup"));
var mediafilesMeta_2 = require("../../selectors/mediafilesMeta");
function cleanupMediafile(mediafile) {
    var _this = this;
    var action = function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var logger, timer, fs, settings, mediafileCleanupTimeout, state, toCleanup, _a, _b, file, e_1_1;
        var e_1, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/cleanupMediafile");
                    timer = _kernel_container_1.default.get("TIMER");
                    fs = _kernel_container_1.default.get("FILESYSTEM");
                    settings = _kernel_container_1.default.get("SETTINGS");
                    mediafileCleanupTimeout = settings.getSetting("CLEANUP_MEDIAFILE_DELAY", 400);
                    state = getState();
                    toCleanup = (0, mediafiles_2.selectMediafile)(mediafile.id, state);
                    if (!toCleanup) return [3, 8];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 6, 7, 8]);
                    _a = __values(toCleanup.files), _b = _a.next();
                    _d.label = 2;
                case 2:
                    if (!!_b.done) return [3, 5];
                    file = _b.value;
                    logger.debug("Removing file", { mediafileId: toCleanup.id, file: file });
                    return [4, fs.removeFile(fs.getFileLocalFilepath(file.filename))];
                case 3:
                    _d.sent();
                    dispatch((0, mediafiles_1.removeMediafileCache)(toCleanup.id, file.filename));
                    _d.label = 4;
                case 4:
                    _b = _a.next();
                    return [3, 2];
                case 5: return [3, 8];
                case 6:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3, 8];
                case 7:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7];
                case 8:
                    if (mediafile.type === "totalCleanup") {
                        dispatch((0, mediafiles_1.removeMediafile)(mediafile.id));
                        logger.debug("Totally removed mediafile", {
                            mediafileId: mediafile.id,
                            mediafile: (0, mediafiles_2.selectMediafile)(mediafile.id, getState()),
                        });
                    }
                    dispatch((0, mediafilesMeta_1.removeMediafileFromCurrentlyCleaningUp)(mediafile.id));
                    timer.setTimeout(function () {
                        logger.debug("Picking next mediafile to cleanup", {
                            queue: Object.values((0, mediafilesMeta_2.selectCleanupQueue)(state)).length,
                            current: Object.values((0, mediafilesMeta_2.selectCurrentCleaningUp)(state)).length,
                        });
                        dispatch((0, startNextMediafileCleanup_1.default)());
                    }, mediafileCleanupTimeout);
                    dispatch({
                        type: cleanupMediafile.type,
                        payload: { mediafileId: mediafile.id },
                    });
                    return [2];
            }
        });
    }); };
    action.type = cleanupMediafile.type;
    return action;
}
exports.default = cleanupMediafile;
cleanupMediafile.type = "cleanupMediafile";
//# sourceMappingURL=cleanupMediafile.js.map